<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">审批</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>安全验证限制</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <audit-list @refresh="refreshList"></audit-list>
    </el-card>
  </div>
</template>

<script>
import './store';
import { mapActions } from 'vuex';
import AuditList from './components/list';

export default {
  name: 'AuthLimit',
  components: {
    AuditList
  },
  methods: {
    ...mapActions('authLimit', ['list']),
    refreshList() {
      this.list();
    }
  },
  mounted() {
    this.list();
  }
};
</script>

<style lang="less" scoped></style>
